import React from 'react';
import EarningsSurpriseWidgetBuilder from './EarningsSurpriseWidgetBuilder';
import EarningsSurpriseWidgetRenderer from './EarningsSurpriseWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { EarningsSurpriseWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBalanceScaleLeft } from '@fortawesome/free-solid-svg-icons';

export { default as EarningsSurpriseWidgetRenderer } from './EarningsSurpriseWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'earnings_surprise',
  meta: {
    label: 'Earnings Surprise',
    icon: React.createElement(FontAwesomeIcon, { icon: faBalanceScaleLeft }),
    description: 'Quarterly EPS beat/miss history: actual vs consensus estimate and surprise %',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'EARNINGS_SURPRISE',
  },
  defaultSize: { w: 6, h: 5, minW: 4, minH: 4 },
  defaultConfig: () => ({} as EarningsSurpriseWidgetConfig),
  Builder: EarningsSurpriseWidgetBuilder,
  Renderer: EarningsSurpriseWidgetRenderer,
  Preview,
};
